import FullscreenSearchResults from './FullscreenSearchResults';

export default FullscreenSearchResults;
